__turbopack_context__.v({
  "blurred": "qJTxEq_blurred",
  "fadeIn": "qJTxEq_fadeIn",
  "filled": "qJTxEq_filled",
  "flipped": "qJTxEq_flipped",
  "high": "qJTxEq_high",
  "issueContent": "qJTxEq_issueContent",
  "issueDesc": "qJTxEq_issueDesc",
  "issuePrinciple": "qJTxEq_issuePrinciple",
  "issueTitle": "qJTxEq_issueTitle",
  "low": "qJTxEq_low",
  "medium": "qJTxEq_medium",
  "preview": "qJTxEq_preview",
  "previewBadge": "qJTxEq_previewBadge",
  "previewBar": "qJTxEq_previewBar",
  "previewContent": "qJTxEq_previewContent",
  "previewDot": "qJTxEq_previewDot",
  "previewHeader": "qJTxEq_previewHeader",
  "previewIssue": "qJTxEq_previewIssue",
  "previewIssues": "qJTxEq_previewIssues",
  "previewTeaser": "qJTxEq_previewTeaser",
  "previewTitle": "qJTxEq_previewTitle",
  "previewWindow": "qJTxEq_previewWindow",
  "severityBar": "qJTxEq_severityBar",
  "severityBars": "qJTxEq_severityBars",
  "severityIndicator": "qJTxEq_severityIndicator",
  "severityLabel": "qJTxEq_severityLabel",
  "slideIn": "qJTxEq_slideIn",
  "teaserBadge": "qJTxEq_teaserBadge",
  "teaserBlur": "qJTxEq_teaserBlur",
  "teaserOverlay": "qJTxEq_teaserOverlay",
  "teaserText": "qJTxEq_teaserText",
});
